import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import { createCustomElement } from "@angular/elements";
import { TranslateModule } from "@ngx-translate/core";

import { TableOfContentsComponent } from './table-of-contents.component';



@NgModule({
  declarations: [
    TableOfContentsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  exports: [
    TableOfContentsComponent
  ]
})
export class TableOfContentsModule {
    constructor(injector: Injector) {
        // Convert `TableOfContentsComponent` to a custom element.
        const TocElement = createCustomElement(TableOfContentsComponent, {injector});
        // Register the custom element with the browser.
        !customElements.get('ngx-toc') && customElements.define('ngx-toc', TocElement);
    }
}
